import * as z from "zod";

import { nameSchema } from "../schema/name";

export const settingsSchema = z.object({
  firstName: nameSchema,
  lastName: nameSchema,
  email: z
    .email({ error: () => "form:error.invalidEmail" })
    .trim()
    .min(6, { message: "form:error.required" }),
  phone: z
    .string({ error: () => "form:error.required" })
    .trim()
    .min(10, { message: "form:error.required" })
    .max(18, { message: "form:error.invalid" }),
});

export type SettingsFormData = z.infer<typeof settingsSchema>;
